export default {
  API_ENDPOINT: 'https://stark-waters-10224.herokuapp.com/api',
  TOKEN_KEY: 'disc-caddy-auth-token'
}